import React from "react";
import { Textarea } from "@/components/ui/textarea";
import { Check } from "lucide-react";

export const EDIT_REASONS = ["Added kilos", "Added products", "Balanced", "Added worker", "Changed date"];
export const joinReason = (tags, text) => [...tags, text.trim()].filter(Boolean).join(", ");

const slug = (r) => r.toLowerCase().replace(/\s+/g, "-");

export function EditReasonPicker({ tags, onTags, text, onText }) {
  const toggle = (r) => onTags(tags.includes(r) ? tags.filter((t) => t !== r) : [...tags, r]);
  return (
    <div data-testid="edit-reason-picker">
      <label className="text-xs font-semibold text-slate-600">Reason for change (tap one or more)</label>
      <div className="flex flex-wrap gap-2 mt-1.5">
        {EDIT_REASONS.map((r) => {
          const on = tags.includes(r);
          return (
            <button key={r} type="button" data-testid={`edit-reason-chip-${slug(r)}`} aria-pressed={on} onClick={() => toggle(r)}
              className={`inline-flex items-center gap-1 h-9 px-3.5 rounded-full text-sm font-semibold border transition-[background-color,color,border-color,transform] duration-150 active:scale-95 ${on ? "bg-teal-500 border-teal-500 text-white shadow-sm" : "bg-white border-slate-200 text-slate-700 hover:border-teal-400"}`}>
              {on && <Check size={14} strokeWidth={3} />}{r}
            </button>
          );
        })}
      </div>
      <Textarea data-testid="edit-reason" placeholder="Add another reason if needed, e.g. corrected from the manual sheet" value={text} onChange={(e) => onText(e.target.value)} className="mt-2" rows={2} />
      {(tags.length > 0 || text.trim()) && <p data-testid="edit-reason-preview" className="text-[11px] text-slate-500 mt-1">Saved as: “{joinReason(tags, text)}”</p>}
    </div>
  );
}
